/* import __COLOCATED_TEMPLATE__ from './section-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();